import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#381d6e] text-[#f7eefa] pt-16 pb-12 border-t border-[#5f2a99]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Main Footer Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 lg:gap-12 pb-14 border-b border-[#5f2a99]">
          
          {/* Brand Col */}
          <div className="space-y-4">
            <div className="flex flex-col">
              <span className="font-serif text-lg sm:text-xl font-bold text-[#faf5f9] leading-tight">
                Ibjerget.dk
              </span>
              <span className="text-xs text-[#e895c8] font-medium leading-tight">
                Golden Eagle Terapier
              </span>
            </div>
            <p className="text-sm text-[#f7eefa] leading-relaxed">
              Et spirituelt behandlerfællesskab på Midtfyn. Et rum for ro, kropsbevidsthed, fordybelse og personlig suverænitet.
            </p>
            <div className="pt-2">
              <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#4a2282] border border-[#5f2a99] text-xs text-[#f7eefa]">
                <i className="fa-solid fa-location-dot text-[#d9238c]"></i>
                Årslev, Midtfyn
              </span>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="font-serif text-lg font-semibold text-[#faf5f9] mb-4">
              Navigation
            </h3>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-white transition-colors flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-[10px] text-[#d9238c]"></i>
                  Forside
                </Link>
              </li>
              <li>
                <Link to="/alt-ansigtsterapi" className="hover:text-white transition-colors flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-[10px] text-[#d9238c]"></i>
                  ALT Ansigtsterapi
                </Link>
              </li>
              <li>
                <Link to="/kropsterapi" className="hover:text-white transition-colors flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-[10px] text-[#d9238c]"></i>
                  Kropsterapi
                </Link>
              </li>
              <li>
                <Link to="/healingmassage" className="hover:text-white transition-colors flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-[10px] text-[#d9238c]"></i>
                  Healingmassage
                </Link>
              </li>
              <li>
                <Link to="/hotstone-massage" className="hover:text-white transition-colors flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-[10px] text-[#d9238c]"></i>
                  Hotstone-massage
                </Link>
              </li>
              <li>
                <Link to="/tarotkortterapi" className="hover:text-white transition-colors flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-[10px] text-[#d9238c]"></i>
                  Tarotkortterapi
                </Link>
              </li>
              <li>
                <Link to="/spirituelle-boeger" className="hover:text-white transition-colors flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-[10px] text-[#d9238c]"></i>
                  Spirituelle bøger
                </Link>
              </li>
              <li>
                <Link to="/foredrag" className="hover:text-white transition-colors flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-[10px] text-[#d9238c]"></i>
                  Foredrag
                </Link>
              </li>
              <li>
                <Link to="/om-os" className="hover:text-white transition-colors flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-[10px] text-[#d9238c]"></i>
                  Om os
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="hover:text-white transition-colors flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-[10px] text-[#d9238c]"></i>
                  Kontakt
                </Link>
              </li>
            </ul>
          </div>

          {/* Kontakt & Behandlere */}
          <div>
            <h3 className="font-serif text-lg font-semibold text-[#faf5f9] mb-4">
              Kontakt & Behandlere
            </h3>
            <div className="space-y-4 text-sm">
              <a
                href="https://maps.google.com/?q=Ibjergvej+12,+5792+Årslev"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-start gap-2.5 hover:text-white transition-colors group"
                title="Åbn adresse i Google Maps"
              >
                <i className="fa-solid fa-map-pin text-[#d9238c] mt-1 group-hover:text-white transition-colors"></i>
                <span>Ibjergvej 12<br />5792 Årslev</span>
              </a>

              {/* Lone Hvid */}
              <div className="pt-1 border-t border-[#5f2a99]">
                <p className="font-semibold text-white text-xs uppercase tracking-wider mb-0.5 text-[#e895c8]">
                  Lone Hvid
                </p>
                <p className="text-[11px] text-[#f7eefa]/80 mb-1.5">
                  Terapeut, kunstner og forfatter • CVR: 42494445
                </p>
                <div className="flex flex-col gap-1 text-xs">
                  <a href="tel:30297902" className="hover:text-white flex items-center gap-2">
                    <i className="fa-solid fa-phone text-[#d9238c]"></i>
                    <span>30 29 79 02</span>
                  </a>
                  <a href="mailto:lone.hvid@hotmail.com" className="hover:text-white flex items-center gap-2">
                    <i className="fa-regular fa-envelope text-[#d9238c]"></i>
                    <span>lone.hvid@hotmail.com</span>
                  </a>
                </div>
              </div>

              {/* Niels Boye */}
              <div className="pt-2 border-t border-[#5f2a99]">
                <p className="font-semibold text-white text-xs uppercase tracking-wider mb-0.5 text-[#e895c8]">
                  Niels Boye
                </p>
                <p className="text-[11px] text-[#f7eefa]/80 mb-1.5">
                  Krops- og psykoterapeut • CVR: 12691807
                </p>
                <div className="flex flex-col gap-1 text-xs">
                  <a href="tel:66157902" className="hover:text-white flex items-center gap-2">
                    <i className="fa-solid fa-phone text-[#d9238c]"></i>
                    <span>66 15 79 02</span>
                  </a>
                  <a href="mailto:niels@ibjerget.dk" className="hover:text-white flex items-center gap-2">
                    <i className="fa-regular fa-envelope text-[#d9238c]"></i>
                    <span>niels@ibjerget.dk</span>
                  </a>
                </div>
              </div>

              <div className="pt-2 text-xs text-[#E2B3D0] space-y-1">
                <p>To selvstændige enkeltmandsvirksomheder på Ibjerget</p>
                <p>Åbningstider: Efter aftale</p>
              </div>
            </div>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between text-xs text-[#E2B3D0] gap-4">
          <p>© {new Date().getFullYear()} Ibjerget.dk – Golden Eagle Terapier. Alle rettigheder forbeholdes.</p>
          <div className="flex items-center gap-6">
            <Link to="/om-os" className="hover:text-white transition-colors">
              Om os
            </Link>
            <Link to="/spirituelle-boeger" className="hover:text-white transition-colors">
              Spirituelle bøger og kunst
            </Link>
            <Link to="/kontakt" className="hover:text-white transition-colors">
              Kontakt
            </Link>
          </div>
        </div>

      </div>
    </footer>
  );
}
